/* eslint-disable import/prefer-default-export */
import _get from 'lodash/get';
import _first from 'lodash/first';

const ZERO_VALUE = 0;

/**
 * @param {Object} elem
 * @param {String} nestedElementClassname
 * @return {Object}
 */
const detectOutOfViewport = (elem, nestedElementClassname) => {
  let element = _get(elem, 'current', null);
  const viewportInformation = {};

  const nestedElement =
    nestedElementClassname && _first(element.getElementsByClassName(nestedElementClassname));
  if (nestedElement) {
    element = nestedElement;
  }

  if (element) {
    const boundingValues = element.getBoundingClientRect();
    const { top, left, bottom, right } = boundingValues;
    const { clientWidth, clientHeight } = document.documentElement;
    const { innerHeight, innerWidth } = window;

    viewportInformation.top = top < ZERO_VALUE;
    viewportInformation.left = left < ZERO_VALUE;
    viewportInformation.bottom = bottom > (innerHeight || clientHeight);
    viewportInformation.right = right > (innerWidth || clientWidth);
    viewportInformation.all =
      viewportInformation.top &&
      viewportInformation.left &&
      viewportInformation.bottom &&
      viewportInformation.right;
    viewportInformation.any =
      viewportInformation.top ||
      viewportInformation.left ||
      viewportInformation.bottom ||
      viewportInformation.right;
  }

  return viewportInformation;
};

export { detectOutOfViewport };
